import { Button } from '@starryui10/Buttons/Button';
import { Option, SelectionOption } from '@starryui10/lists/SelectionOption';
import { ManagedDropdown, useManagedDropdown } from '@starryui10/ManagedDropdown/ManagedDropdown';
import React from 'react';
import { useEntryDirectoryEvents } from '../../context/EntryDirectoryContext';
import { strings } from '../../localization';
import { useDirectoryDispatch, useDirectoryState } from '../../state/DirectoryState';
import { showEntrySearchScreen } from '../../state/Observables';

export const SavedFilterControl = () => {
    return (
        <>
            <ManagedDropdown
                placement="bottom-start"
                manager={(onClick) => (
                    <Button compact icon="Plus" variant="Secondary" onClick={onClick}>
                        {strings.Action_AddEntries}
                    </Button>
                )}
            >
                <Options />
            </ManagedDropdown>
        </>
    );
};

const Options = () => {
    const { scanToAddEntry, searchToAddEntry } = useEntryDirectoryEvents();
    const { data } = useDirectoryState();
    const { dispatch } = useDirectoryDispatch();
    const { closeDropdown } = useManagedDropdown();

    const handleScanToAddEntry = () => {
        closeDropdown();
        scanToAddEntry(data!.allMainDirectory.currentView.id!);
    };

    const handleSearchToAddEntry = () => {
        closeDropdown();
        showEntrySearchScreen({
            visible: true,
            result: (ids) => {
                searchToAddEntry(data!.allMainDirectory.currentView.id!, ids).then(() => {
                    dispatch({ type: 'RELOAD' });
                });
            },
        });
    };

    return (
        <SelectionOption>
            <Option icon="Search" caption="Search to Add" onClick={handleSearchToAddEntry} />
            <Option icon="Barcode" caption="Scan to Add" onClick={handleScanToAddEntry} />
        </SelectionOption>
    );
};
